export default __webpack_public_path__ + "static/media/login_bg.f9bb62c6.jpg";